import React from "react";

const CourseAccessFeature = ({ stepNumber = 5, onExploreClick }) => {
  return (
    <div className="backdrop-blur-[7.5px] bg-[rgba(64,106,255,0.05)] flex flex-col items-center pb-6 pt-0 px-3 relative rounded-xl w-full shadow-[0px_-4px_20px_0px_rgba(0,0,0,0.3)]">
      {/* Top decorative element */}
      <img alt="" className="w-full -mt-5 h-[50px]" src="https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Ellipse%201270.png"/>

      {/* Main content container */}
      <div className="flex flex-col gap-4 items-center relative w-full">
        {/* Header section with step number and title */}
        <div className="flex flex-col gap-3 items-center relative w-full">
          {/* Step number badge */}
          <div className="border-[#c1dcff] border-[1.5px] border-solid flex items-center justify-center p-[10px] relative rounded-[24px] w-6 h-6">
            <p 
              className="font-bold text-[14px] leading-none tracking-[-0.14px] font-['Inter']"
              style={{
                background: "linear-gradient(180deg, #c1dcff 0%, #406aff 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text"
              }}
            >
              {stepNumber}
            </p>
          </div>

          {/* Title and description */}
          <div className="flex flex-col gap-[6px] items-center w-full">
            <h2 
              className="font-bold text-[16px] leading-none tracking-[-0.16px] text-center font-['Inter'] capitalize"
              style={{
                background: "linear-gradient(90deg, rgba(193, 220, 255, 1) 0%, rgba(13, 91, 249, 1) 117.87%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text"
              }}
            >
              Access To 3,174+ Courses
            </h2>
            
            <p className="font-normal text-[12px] leading-normal text-center text-[rgba(255,255,255,0.7)] font-['Inter'] whitespace-pre-wrap max-w-full">
              Build in-demand skills with a lifetime course access
            </p>
          </div>
        </div>

       <img alt="" className="w-[70%]" src="https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Stats/Frame%2023315.webp"/>
      </div>
    </div>
  );
};

export default CourseAccessFeature;
